import { render, staticRenderFns } from "./contractsTable.vue?vue&type=template&id=1203a0fc&scoped=true&"
import script from "./contractsTable.vue?vue&type=script&lang=js&"
export * from "./contractsTable.vue?vue&type=script&lang=js&"
import style0 from "./contractsTable.vue?vue&type=style&index=0&id=1203a0fc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1203a0fc",
  null
  
)

export default component.exports